import { useContext } from 'react';
import WsContext from './ws-context';
import type { WsContextValue } from './types';

// ----------------------------------------------------------------------

/**
 * Hook to access WebSocket context
 * Must be used inside WsProvider
 */
export const useWsContext = (): WsContextValue => {
  const context = useContext(WsContext);

  if (!context) {
    throw new Error('useWsContext must be used within a WsProvider');
  }

  return context;
};

// Re-export all types
export * from './types';
export { useWsConnection, useWsHandlers } from './hooks';
